module.exports = __webpack_public_path__ + "img/clouds-with-lighting-littlerain.61aa7349.png";